import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from '../../../services/general.service';
import {Injectable} from '@angular/core';
import {IScannedData} from '../interfaces/IScannedData';
import {Page} from '../../../model/page';

@Injectable()
export class ScannedDataService extends GeneralService {

    static UPLOAD_FLAG_DEFAULT = 0;
    static UPLOAD_FLAG_PROCESSING = 1;
    static UPLOAD_FLAG_SENT = 2;
    static UPLOAD_FLAG_RESEND = 5;
    static UPLOAD_FLAG_RESENDING = 6;
    static UPLOAD_FLAG_IMPORTED = 10;
    static UPLOAD_FLAG_COMPLETED = 20;

    static URL_SD1 = 'scanned-data';
    static MIRROR_URL_SD1 = '/order-entry-system/' + ScannedDataService.URL_SD1;
    static MOBILE_MIRROR_URL_SD1 = '/mobile/oes/' + ScannedDataService.URL_SD1;
    static DEFAULT_LABEL_SD1 = 'Scanned Data';
    static LABEL_SD1 = 'Replenishment Data';
    static MODE_SD1 = 'sd1';

    static URL_SD2 = 'consumption-data';
    static MIRROR_URL_SD2 = '/order-entry-system/' + ScannedDataService.URL_SD2;
    static MOBILE_MIRROR_URL_SD2 = '/mobile/oes/' + ScannedDataService.URL_SD2;
    static LABEL_SD2 = 'Consumption Data';
    static MODE_SD2 = 'sd2';

    static URL_SD3 = 'receiving-data';
    static MIRROR_URL_SD3 = '/order-entry-system/' + ScannedDataService.URL_SD3;
    static MOBILE_MIRROR_URL_SD3 = '/mobile/oes/' + ScannedDataService.URL_SD3;
    static LABEL_SD3 = 'Receiving Data';
    static MODE_SD3 = 'sd3';

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    public getById(id: number, mode: string): Observable<any> {
        const url = `${this.apiUrl}/scanned-data/view`;
        return this.http.get(url, {params: {ID: id.toString(), mode: mode}});
    }

    public findMatches(searchText: string, mode: string): Observable<any> {
        const url = `${this.apiUrl}/scanned-data/find-match`;
        return this.http.get(url, {params: {searchText: searchText, mode: mode}});
    }

    public save(data: any): Observable<any> {
        const url = `${this.apiUrl}/scanned-data/update`;
        return this.http.post(url, data);
    }

    public delete(id: number, mode: string): Observable<any> {
        const url = `${this.apiUrl}/scanned-data/delete`;
        return this.http.post(url, {ID: id.toString(), mode: mode});
    }

    public resend(SD1_IDs: Array<string>): Observable<any> {
        const url = `${this.apiUrl}/scanned-data/resend`;
        return this.http.post(url, {SD1_IDs: SD1_IDs});
    }

    export(preferences, page): Observable<any> {
        const url = '/scanned-data/export';
        let params = new HttpParams();
        params = this.applyFilters(page, params);
        params = params.append('col', preferences.columns);
        params = params.append('offset', (new Date()).getTimezoneOffset().toString());
        return this.http.get(this.apiUrl + url, {params: params});
    }

    generateXls(xlsData: HttpResponse<Blob>, fileName: string) {
        super.generateXls(xlsData, fileName);
    }

    public getDataList(page: Page): Observable<any> {
        const url = '/scanned-data';
        return this.getRestList(page, url);
    }

    public getScannedDataUploadFlags() {
        return [
            {value: null, text: 'All'},
            {value: ScannedDataService.UPLOAD_FLAG_DEFAULT, text: 'Open'},
            {value: ScannedDataService.UPLOAD_FLAG_RESEND, text: 'Open (Resend)'},
            {value: ScannedDataService.UPLOAD_FLAG_PROCESSING, text: 'Processing'},
            {value: ScannedDataService.UPLOAD_FLAG_RESENDING, text: 'Resending'},
            {value: ScannedDataService.UPLOAD_FLAG_SENT, text: 'Sent'},
            {value: ScannedDataService.UPLOAD_FLAG_IMPORTED, text: 'External Import'}
        ];
    }

    public getConsumptionDataUploadFlags() {
        return [
            {value: null, text: 'All'},
            {value: ScannedDataService.UPLOAD_FLAG_DEFAULT, text: 'Open'},
            {value: ScannedDataService.UPLOAD_FLAG_COMPLETED, text: 'Completed'}
        ];
    }

    public getReceivingDataUploadFlags() {
        return [
            {value: null, text: 'All'},
            {value: ScannedDataService.UPLOAD_FLAG_DEFAULT, text: 'Open'},
            {value: ScannedDataService.UPLOAD_FLAG_COMPLETED, text: 'Completed'}
        ];
    }

    public getNavigationUrl(mode: string) {
        let url = '';
        if (mode === ScannedDataService.MODE_SD2) {
            url = ScannedDataService.URL_SD2;
        } else if (mode === ScannedDataService.MODE_SD3) {
            url = ScannedDataService.URL_SD3;
        } else {
            url = ScannedDataService.URL_SD1;
        }
        return url;
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/scanned-data.service.ts